import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { PageAlert } from "capitalrx-components";
import { TransmissionTypes } from "@/types";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { transmissionTestAsBatchActions } from "@/App/actions";

function* transmissionTestAsBatch(payload: TransmissionTypes.TransmissionData): Generator {
  return yield apiService({
    url: "/transmission/process_test_as_batch",
    method: "POST",
    data: payload,
  });
}

export function* transmissionTestAsBatchWorker(
  action: ReturnType<typeof transmissionTestAsBatchActions.submitTransmissionTestAsBatch>,
): SagaIterator {
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const result = yield call(transmissionTestAsBatch, payload);
    const { id } = result;
    yield put(stopSubmit(formName));
    window.open(`/test-claim/batch/view/${id}`, "_blank");
  } catch (error) {
    const { data: { message = error.message } = {} } = error || {};

    yield put(showPageAlert({ show: true, type: "error", message: message }));
    yield put(stopSubmit(formName));
  }
}

export default function* transmissionTestAsBatchWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SUBMIT_TRANSMISSION_TEST_AS_BATCH, transmissionTestAsBatchWorker);
}
